var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTurnover(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#176318"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 20C30 22.2199 29.2613 24.3767 27.9004 26.1305C26.5395 27.8843 24.6337 29.1355 22.4833 29.6867C20.333 30.238 18.0603 30.0581 16.0234 29.1754C13.9866 28.2926 12.3014 26.7572 11.2334 24.8111C10.1654 22.865 9.77527 20.6188 10.1246 18.4266C10.4739 16.2343 11.5427 14.2206 13.1626 12.7028C14.7825 11.1849 16.8614 10.2492 19.0718 10.0432C21.2821 9.83711 23.4981 10.3724 25.3707 11.5646L24.2966 13.2517C22.7985 12.2979 21.0257 11.8697 19.2574 12.0345C17.4891 12.1994 15.826 12.9479 14.5301 14.1622C13.2341 15.3765 12.3791 16.9874 12.0996 18.7412C11.8202 20.4951 12.1323 22.292 12.9867 23.8489C13.8411 25.4057 15.1893 26.6341 16.8188 27.3403C18.4482 28.0465 20.2664 28.1904 21.9867 27.7494C23.707 27.3084 25.2316 26.3075 26.3203 24.9044C27.4091 23.5014 28 21.7759 28 20H30Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3505 15.6378C28.5395 16.0625 28.0973 16.4927 27.6779 16.2921L22.6715 13.8972C22.3577 13.7471 22.2893 13.3304 22.5387 13.0878L25.2887 10.4124C25.538 10.1698 25.9527 10.2497 26.0941 10.5675L28.3505 15.6378Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTurnover);
export default __webpack_public_path__ + "static/media/Turnover.5b56da3830a0f4acbf8f321541af9e81.svg";
export { ForwardRef as ReactComponent };